import * as Yup from 'yup';
import { TFunction } from 'i18next';
import { boundry, ContractRecalculationFormValues } from './ContractRecalculationFormValues';

type FormatNumber = (value: number) => string;

// strips the thousands separator added by the CleaveInput mileage formatting
export const parseMileageValue = (value: number | string): number =>
    typeof value === 'string' ? Number(value.replace(/\./g, '')) : value;

export const getContractRecalculationValidationSchema = (
    t: TFunction,
    _currentDuration: number,
    _currentMileage: number,
    formatNumber: FormatNumber = String,
): Yup.SchemaOf<ContractRecalculationFormValues> =>
    Yup.object({
        durationValue: Yup.number()
            .required(t('form.validation.duration-required'))
            .min(_currentDuration, t('form.validation.duration-min', { min: formatNumber(_currentDuration) }))
            .max(
                boundry.duration.maximum,
                t('form.validation.duration-max', { max: formatNumber(boundry.duration.maximum) }),
            ),
        distanceValue: Yup.number()
            .transform((_value, originalValue) => parseMileageValue(originalValue))
            .typeError(t('form.validation.mileage-invalid'))
            .required(t('form.validation.mileage-required'))
            .min(
                boundry.distance.minimum,
                t('form.validation.mileage-min', { min: formatNumber(boundry.distance.minimum) }),
            )
            .max(
                boundry.distance.maximum,
                t('form.validation.mileage-max', { max: formatNumber(boundry.distance.maximum) }),
            ),
        comment: Yup.string()
            .trim()
            .ensure(),
    });
